import { jsx } from "react/jsx-runtime";
import { styled, useThemeProps } from "@mui/material";
import { ActionBarItem } from "../../ActionBar/index.js";
import { editorQuickInsertItemName } from "./classes.js";
function EditorQuickInsertItemBase(inProps) {
  const props = useThemeProps({
    name: editorQuickInsertItemName,
    props: inProps
  });
  const { label, tooltip = label, ...rest } = props;
  return /* @__PURE__ */ jsx(ActionBarItem, { tooltip, label, ...rest });
}
const EditorQuickInsertItem = styled(EditorQuickInsertItemBase, {
  name: editorQuickInsertItemName,
  slot: "Root",
  overridesResolver: (_, styles) => styles.root
})(() => ({
  textTransform: "none"
}));
export {
  EditorQuickInsertItem
};
//# sourceMappingURL=EditorQuickInsertItem.js.map
